export const INIT = 'app/DonationSchedulePage/INIT';
export const INIT_SUCCESS = 'app/DonationSchedulePage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DonationSchedulePage/INIT_FAILED';
export const CANCEL_DONATION_SCHEDULE = 'app/DonationSchedulePage/CANCEL_DONATION_SCHEDULE';
